import React from 'react'
import { localized } from '@/decorators/localized'
import Resx from '@/components/Resx'
import { Form, Input, Label, FormGroup } from 'reactstrap'
import ReportTemplateSelector from '@/components/reporting/reportTemplateSelector'
import { Validator } from '@/components/validation'

@localized()
class OutputReportGroupDefinitionFormContent extends React.Component {
  onNameChange = (e) => this.props.onChange({ name: e.target.value })
  onLatinNameChange = (e) => this.props.onChange({ latinName: e.target.value })
  onTemplatesChange = (templates) => this.props.onChange({ templates })
  render () {
    return (
      <Form>
        <FormGroup>
          <Label><Resx name='Common.Name' /></Label>
          <Validator name='name' value={this.props.name} required>
            <Input value={this.props.name} onChange={this.onNameChange} />
          </Validator>
        </FormGroup>
        <FormGroup>
          <Label><Resx name='Common.LatinName' /></Label>
          <Validator name='latinName' value={this.props.latinName} required>
            <Input value={this.props.latinName} onChange={this.onLatinNameChange} />
          </Validator>
        </FormGroup>
        <FormGroup>
          <Label><Resx name='Reporting.MultipleInstitutions' /></Label>:
          <span className='ml-1'>{this.props.multipleInstitutions ? <Resx name='Common.Yes' /> : <Resx name='Common.No' />}</span>
        </FormGroup>
        <FormGroup>
          <div>
            <ReportTemplateSelector
              outputTemplates
              selectedTemplates={this.props.templates}
              onChange={this.onTemplatesChange}
            />
          </div>
        </FormGroup>
        {this.props.children}
      </Form>
    )
  }
}

export default OutputReportGroupDefinitionFormContent



// WEBPACK FOOTER //
// ./src/internal-app/pages/outputReportGroupDefinitions/formContent.js